import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getRazonSocialClientesActivos`, method: 'GET', body: null, token: token})
}